import { getWrapper } from './axios'
import { formDataToRequestParams } from './helpers'
import {
    DeleteLocationPayload,
    FetchLocationListPayload,
    FetchLocationPayload,
    SubmitLocationPayload,
    SubmitLocationType,
    UserLocationsTyping
} from '../store/flashing/flashingTypings'

export const postSubmitLocation = (params: SubmitLocationType): Promise<{ status: 'error' | 'success' }> => {
    return getWrapper(
        '/location/submit/',
        formDataToRequestParams<SubmitLocationType>(params),
        true
    ) as Promise<SubmitLocationPayload>
}

export const getGeoLocationList = (params: UserLocationsTyping): Promise<FetchLocationListPayload> => {
    return getWrapper('/location/list/', { params }) as Promise<FetchLocationListPayload>
}

export const getFlashingLocation = (params: { id: number }): Promise<FetchLocationPayload> => {
    return getWrapper('/location/get/', { params }) as Promise<FetchLocationPayload>
}

export const getFlashingLocationMaterials = (params: {
    id: number
    limit: number
    offset: number
}): Promise<FetchLocationPayload> => {
    return getWrapper('/location/material/list/', { params }) as Promise<FetchLocationPayload>
}

export const deleteEmptyLocation = (params: { id: number }): Promise<DeleteLocationPayload> => {
    return getWrapper('/location/delete/', { params }) as Promise<DeleteLocationPayload>
}
